import List from "Components/List/List";
import {IBiCustomerProjectLine} from "Apis/Models/IBiDto";
import { useTranslation } from "react-i18next";
import {formatNumber} from "Utils/NumberUtils";
import MoneyIcon from "Assets/SVG/MoneyIcon";
import TotalComponent from "Components/TotalComponent";
import OrdersIcon from "../../../Assets/SVG/OrdersIcon";

interface IProps {
    lines?: IBiCustomerProjectLine[];
    isLoading: boolean;
    onOrderByChange?: (orderBy: string, orderByDirection: string) => void,
}
const BiCustomerProjectList = (props: IProps) => {

    const { lines, isLoading } = props;
    
    const { t } = useTranslation();
    
    return (
        <>
            <List<IBiCustomerProjectLine> onOrderByChanged={props.onOrderByChange} data={lines} loading={isLoading} columns={[
                {
                    title: t('customer'),
                    textRender: (record) => record.customer.name,
                    allowOrderBy: true,
                    fieldName: "customer",
                },
                {
                    title: t('project'),
                    textRender: (record) => record.project?.name ?? '',
                    allowOrderBy: true,
                    fieldName: "project",
                },
                {
                    title: t('quantity'),
                    textRender: (record) => record.orderCount.toString(),
                    size: "min-content",
                    allowOrderBy: true,
                    fieldName: "quantity",
                },
                {
                    title: t('TotalCost'),
                    textRender: (record) => `${formatNumber(record.totalCost)} DKK`,
                    size: 'auto',
                    allowOrderBy: true,
                    fieldName: "cost",
                },
                {
                    title: t('Total'),
                    textRender: (record) => `${formatNumber(record.total)} DKK`,
                    size: 'auto',
                    allowOrderBy: true,
                    fieldName: "total",
                },
            ]} keyExtractor={(record) => record.key?.toString()} />
            
            <TotalComponent 
                firstHeader={t('quantity')}
                firstTotal={lines?.reduce((acc, curr) => acc + curr.orderCount, 0).toString() ?? ''}
                firstIcon={<OrdersIcon />}
                secondHeader={t('totalCost')}
                secondTotal={`${formatNumber(lines?.reduce((acc, curr) => acc + curr.totalCost, 0) ?? 0)} DKK`}
                secondIcon={<MoneyIcon />}
                thirdHeader={t('totalSalesExclVat')}
                thirdTotal={`${formatNumber(lines?.reduce((acc, curr) => acc + curr.total, 0) ?? 0)} DKK`}
                thirdIcon={<MoneyIcon />}
                fourthHeader={t('totalInclVat')}
                fourthTotal={`${formatNumber((lines?.reduce((acc, curr) => acc + curr.total, 0) ?? 0) * 1.25)} DKK`}
                fourthIcon={<MoneyIcon />}
            />
        </>
    )

}

export default BiCustomerProjectList